// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AddSubscriberData,
  AddSubscriberResponses,
  ChangePasswordData,
  ChangePasswordResponses,
  CheckBulletinsData,
  CheckBulletinsResponses,
  CheckPasswordData,
  CheckPasswordResponses,
  CreateIncidentData,
  CreateIncidentResponses,
  CreateJsonBulletinData,
  CreateJsonBulletinResponses,
  CreateJsonBulletinsData,
  CreateJsonBulletinsResponses,
  DeleteGenericObservationData,
  DeleteGenericObservationResponses,
  DeleteIncidentAttachmentData,
  DeleteIncidentAttachmentResponses,
  DeleteIncidentData,
  DeleteIncidentResponses,
  DeleteJsonBulletinData,
  DeleteJsonBulletinResponses,
  DeleteUserData,
  DeleteUserResponses,
  DeleteVariantData,
  DeleteVariantResponses,
  GetBlogPostData,
  GetBlogPostResponses,
  GetBlogPostsData,
  GetBlogPostsResponses,
  GetBulletinCsvData,
  GetBulletinCsvResponses,
  GetCaamlJsonBulletinsData,
  GetCaamlJsonBulletinsResponses,
  GetChecklistsData,
  GetChecklistsResponses,
  GetDangerSourceCsvData,
  GetDangerSourceCsvResponses,
  GetDangerSourcesData,
  GetDangerSourcesResponses,
  GetExternalServerConfigurationsData,
  GetExternalServerConfigurationsResponses,
  GetGenericObservationData,
  GetGenericObservationResponses,
  GetGenericObservationsData,
  GetGenericObservationsResponses,
  GetHighestDangerRatingData,
  GetHighestDangerRatingResponses,
  GetIncidentAttachmentData,
  GetIncidentAttachmentResponses,
  GetIncidentData,
  GetIncidentResponses,
  GetIncidentsData,
  GetIncidentsResponses,
  GetInternalStatus1Data,
  GetInternalStatus1Responses,
  GetInternalStatusData,
  GetInternalStatusResponses,
  GetJsonBulletinData,
  GetJsonBulletinResponses,
  GetJsonBulletinsData,
  GetJsonBulletinsResponses,
  GetLatestData,
  GetLatestResponses,
  GetLocalServerConfigurationData,
  GetLocalServerConfigurationResponses,
  GetOpenApiData,
  GetOpenApiJsonData,
  GetOpenApiJsonResponses,
  GetOpenApiResponses,
  GetPreviewPdfData,
  GetPreviewPdfResponses,
  GetPublicationStatusData,
  GetPublicationStatusResponses,
  GetPublishedBulletinsAsPdfData,
  GetPublishedBulletinsAsPdfResponses,
  GetPublishedCaamlBulletinsData,
  GetPublishedCaamlBulletinsResponses,
  GetPublishedCaamlJsonBulletinsData,
  GetPublishedCaamlJsonBulletinsResponses,
  GetPublishedJsonBulletins0Data,
  GetPublishedJsonBulletins0Responses,
  GetPublishedJsonBulletinsData,
  GetPublishedJsonBulletinsResponses,
  GetRegionData,
  GetRegionResponses,
  GetRegions1Data,
  GetRegions1Responses,
  GetRegionsData,
  GetRegionsResponses,
  GetRolesData,
  GetRolesResponses,
  GetRssFeedData,
  GetRssFeedResponses,
  GetServerVersionInfoData,
  GetServerVersionInfoResponses,
  GetStatus1Data,
  GetStatus1Responses,
  GetStatusData,
  GetStatusResponses,
  GetStressLevelsData,
  GetStressLevelsResponses,
  GetTeamStressLevelsData,
  GetTeamStressLevelsResponses,
  GetUsersData,
  GetUsersResponses,
  GetVariantByIdData,
  GetVariantByIdResponses,
  GetVariantsData,
  GetVariantsForDangerSourceData,
  GetVariantsForDangerSourceResponses,
  GetVariantsResponses,
  IndexData,
  IndexResponses,
  KeyData,
  KeyResponses,
  LoginData,
  LoginResponses,
  PostStressLevelData,
  PostStressLevelResponses,
  PublishAllBulletinsData,
  PublishAllBulletinsResponses,
  PublishBulletinsData,
  PublishBulletinsResponses,
  PublishIncidentData,
  PublishIncidentResponses,
  ReplaceVariantsData,
  ReplaceVariantsResponses,
  ResetPasswordData,
  ResetPasswordResponses,
  SaveChecklistData,
  SaveChecklistResponses,
  SaveDangerSourceData,
  SaveDangerSourceResponses,
  SaveDangerSourceVariantData,
  SaveDangerSourceVariantResponses,
  SaveMediaFileData,
  SaveMediaFileResponses,
  SaveOrUpdateGenericObservationData,
  SaveOrUpdateGenericObservationResponses,
  SaveRegionData,
  SaveRegionResponses,
  SaveServerConfigurationData,
  SaveServerConfigurationResponses,
  SaveUserData,
  SaveUserResponses,
  SaveVirtualRealityStatisticsData,
  SaveVirtualRealityStatisticsResponses,
  SendEmailData,
  SendEmailResponses,
  SendLatestBlogPostData,
  SendLatestBlogPostEmailData,
  SendLatestBlogPostEmailResponses,
  SendLatestBlogPostPushData,
  SendLatestBlogPostPushResponses,
  SendLatestBlogPostResponses,
  SendLatestBlogPostTelegramData,
  SendLatestBlogPostTelegramResponses,
  SendLatestBlogPostWhatsAppData,
  SendLatestBlogPostWhatsAppResponses,
  SubmitBulletinsData,
  SubmitBulletinsResponses,
  SubscribeData,
  SubscribeResponses,
  TestAuthData,
  TestAuthResponses,
  TriggerPushNotificationsData,
  TriggerPushNotificationsResponses,
  TriggerStatusChecksData,
  TriggerStatusChecksResponses,
  TriggerTelegramChannelData,
  TriggerTelegramChannelResponses,
  TriggerWhatsAppChannelData,
  TriggerWhatsAppChannelResponses,
  UnpublishIncidentData,
  UnpublishIncidentResponses,
  UnsubscribeData,
  UnsubscribeResponses,
  UpdateIncidentData,
  UpdateIncidentResponses,
  UpdateJsonBulletinData,
  UpdateJsonBulletinResponses,
  UploadBulletinPhotoData,
  UploadBulletinPhotoResponses,
  UploadIncidentAttachmentData,
  UploadIncidentAttachmentResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const index = <ThrowOnError extends boolean = false>(
  options?: Options<IndexData, ThrowOnError>,
): RequestResult<IndexResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<IndexResponses, unknown, ThrowOnError>({ url: "/", ...options });

/**
 * Authenticate user
 */
export const login = <ThrowOnError extends boolean = false>(
  options: Options<LoginData, ThrowOnError>,
): RequestResult<LoginResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<LoginResponses, unknown, ThrowOnError>({
    url: "/authentication",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Test access token
 */
export const testAuth = <ThrowOnError extends boolean = false>(
  options?: Options<TestAuthData, ThrowOnError>,
): RequestResult<TestAuthResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<TestAuthResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/authentication/test",
    ...options,
  });

export const getBlogPost = <ThrowOnError extends boolean = false>(
  options: Options<GetBlogPostData, ThrowOnError>,
): RequestResult<GetBlogPostResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetBlogPostResponses, unknown, ThrowOnError>({ url: "/blogs/post", ...options });

export const getBlogPosts = <ThrowOnError extends boolean = false>(
  options: Options<GetBlogPostsData, ThrowOnError>,
): RequestResult<GetBlogPostsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetBlogPostsResponses, unknown, ThrowOnError>({ url: "/blogs/posts", ...options });

export const sendLatestBlogPost = <ThrowOnError extends boolean = false>(
  options: Options<SendLatestBlogPostData, ThrowOnError>,
): RequestResult<SendLatestBlogPostResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SendLatestBlogPostResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/blogs/publish/latest",
    ...options,
  });

export const sendLatestBlogPostEmail = <ThrowOnError extends boolean = false>(
  options: Options<SendLatestBlogPostEmailData, ThrowOnError>,
): RequestResult<SendLatestBlogPostEmailResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SendLatestBlogPostEmailResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/blogs/publish/latest/email",
    ...options,
  });

export const sendLatestBlogPostPush = <ThrowOnError extends boolean = false>(
  options: Options<SendLatestBlogPostPushData, ThrowOnError>,
): RequestResult<SendLatestBlogPostPushResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SendLatestBlogPostPushResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/blogs/publish/latest/push",
    ...options,
  });

export const sendLatestBlogPostTelegram = <ThrowOnError extends boolean = false>(
  options: Options<SendLatestBlogPostTelegramData, ThrowOnError>,
): RequestResult<SendLatestBlogPostTelegramResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SendLatestBlogPostTelegramResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/blogs/publish/latest/telegram",
    ...options,
  });

export const sendLatestBlogPostWhatsApp = <ThrowOnError extends boolean = false>(
  options: Options<SendLatestBlogPostWhatsAppData, ThrowOnError>,
): RequestResult<SendLatestBlogPostWhatsAppResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SendLatestBlogPostWhatsAppResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/blogs/publish/latest/whatsapp",
    ...options,
  });

/**
 * @deprecated
 */
export const getPublishedJsonBulletins0 = <ThrowOnError extends boolean = false>(
  options: Options<GetPublishedJsonBulletins0Data, ThrowOnError>,
): RequestResult<GetPublishedJsonBulletins0Responses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetPublishedJsonBulletins0Responses, unknown, ThrowOnError>({
    querySerializer: { parameters: { regions: { array: { explode: false } } } },
    url: "/bulletins",
    ...options,
  });

/**
 * Create bulletins
 */
export const createJsonBulletins = <ThrowOnError extends boolean = false>(
  options: Options<CreateJsonBulletinsData, ThrowOnError>,
): RequestResult<CreateJsonBulletinsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateJsonBulletinsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create bulletin
 */
export const createJsonBulletin = <ThrowOnError extends boolean = false>(
  options: Options<CreateJsonBulletinData, ThrowOnError>,
): RequestResult<CreateJsonBulletinResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CreateJsonBulletinResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get published bulletins for date as CAAML XML
 */
export const getPublishedCaamlBulletins = <ThrowOnError extends boolean = false>(
  options: Options<GetPublishedCaamlBulletinsData, ThrowOnError>,
): RequestResult<GetPublishedCaamlBulletinsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetPublishedCaamlBulletinsResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { regions: { array: { explode: false } } } },
    url: "/bulletins/caaml",
    ...options,
  });

/**
 * Get published bulletins for date as CAAML JSON
 */
export const getPublishedCaamlJsonBulletins = <ThrowOnError extends boolean = false>(
  options: Options<GetPublishedCaamlJsonBulletinsData, ThrowOnError>,
): RequestResult<GetPublishedCaamlJsonBulletinsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetPublishedCaamlJsonBulletinsResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { regions: { array: { explode: false } } } },
    url: "/bulletins/caaml/json",
    ...options,
  });

/**
 * Check bulletins
 */
export const checkBulletins = <ThrowOnError extends boolean = false>(
  options: Options<CheckBulletinsData, ThrowOnError>,
): RequestResult<CheckBulletinsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CheckBulletinsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/check",
    ...options,
  });

/**
 * Get bulletins for date
 */
export const getJsonBulletins = <ThrowOnError extends boolean = false>(
  options: Options<GetJsonBulletinsData, ThrowOnError>,
): RequestResult<GetJsonBulletinsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetJsonBulletinsResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { regions: { array: { explode: false } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/edit",
    ...options,
  });

/**
 * Get bulletins for date as CAAML JSON
 */
export const getCaamlJsonBulletins = <ThrowOnError extends boolean = false>(
  options: Options<GetCaamlJsonBulletinsData, ThrowOnError>,
): RequestResult<GetCaamlJsonBulletinsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetCaamlJsonBulletinsResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { regions: { array: { explode: false } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/edit/caaml/json",
    ...options,
  });

/**
 * Get highest danger rating
 */
export const getHighestDangerRating = <ThrowOnError extends boolean = false>(
  options: Options<GetHighestDangerRatingData, ThrowOnError>,
): RequestResult<GetHighestDangerRatingResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetHighestDangerRatingResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { regions: { array: { explode: false } } } },
    url: "/bulletins/highest",
    ...options,
  });

/**
 * Get published bulletins for date
 */
export const getPublishedJsonBulletins = <ThrowOnError extends boolean = false>(
  options: Options<GetPublishedJsonBulletinsData, ThrowOnError>,
): RequestResult<GetPublishedJsonBulletinsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetPublishedJsonBulletinsResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { regions: { array: { explode: false } } } },
    url: "/bulletins/json",
    ...options,
  });

/**
 * Get latest bulletin date
 */
export const getLatest = <ThrowOnError extends boolean = false>(
  options?: Options<GetLatestData, ThrowOnError>,
): RequestResult<GetLatestResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetLatestResponses, unknown, ThrowOnError>({ url: "/bulletins/latest", ...options });

/**
 * Get published bulletins as PDF
 */
export const getPublishedBulletinsAsPdf = <ThrowOnError extends boolean = false>(
  options: Options<GetPublishedBulletinsAsPdfData, ThrowOnError>,
): RequestResult<GetPublishedBulletinsAsPdfResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetPublishedBulletinsAsPdfResponses, unknown, ThrowOnError>({
    url: "/bulletins/pdf",
    ...options,
  });

/**
 * Upload bulletin photo
 */
export const uploadBulletinPhoto = <ThrowOnError extends boolean = false>(
  options: Options<UploadBulletinPhotoData, ThrowOnError>,
): RequestResult<UploadBulletinPhotoResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UploadBulletinPhotoResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/photo",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Get bulletin preview as PDF
 */
export const getPreviewPdf = <ThrowOnError extends boolean = false>(
  options: Options<GetPreviewPdfData, ThrowOnError>,
): RequestResult<GetPreviewPdfResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<GetPreviewPdfResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/preview",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Publish a major update to an already published bulletin (not at 5PM nor 8AM).
 *
 * Publish a major update to an already published bulletin (not at 5PM nor 8AM).
 */
export const publishBulletins = <ThrowOnError extends boolean = false>(
  options: Options<PublishBulletinsData, ThrowOnError>,
): RequestResult<PublishBulletinsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PublishBulletinsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/publish",
    ...options,
  });

/**
 * Publish a major update to an already published bulletin (not at 5PM nor 8AM).
 *
 * Publish a major update to an already published bulletin (not at 5PM nor 8AM).
 */
export const publishAllBulletins = <ThrowOnError extends boolean = false>(
  options: Options<PublishAllBulletinsData, ThrowOnError>,
): RequestResult<PublishAllBulletinsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PublishAllBulletinsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/publish/all",
    ...options,
  });

export const sendEmail = <ThrowOnError extends boolean = false>(
  options: Options<SendEmailData, ThrowOnError>,
): RequestResult<SendEmailResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SendEmailResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/publish/email",
    ...options,
  });

export const triggerPushNotifications = <ThrowOnError extends boolean = false>(
  options: Options<TriggerPushNotificationsData, ThrowOnError>,
): RequestResult<TriggerPushNotificationsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<TriggerPushNotificationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/publish/push",
    ...options,
  });

export const triggerTelegramChannel = <ThrowOnError extends boolean = false>(
  options: Options<TriggerTelegramChannelData, ThrowOnError>,
): RequestResult<TriggerTelegramChannelResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<TriggerTelegramChannelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/publish/telegram",
    ...options,
  });

export const triggerWhatsAppChannel = <ThrowOnError extends boolean = false>(
  options: Options<TriggerWhatsAppChannelData, ThrowOnError>,
): RequestResult<TriggerWhatsAppChannelResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<TriggerWhatsAppChannelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/publish/whatsapp",
    ...options,
  });

export const getStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetStatusData, ThrowOnError>,
): RequestResult<GetStatusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetStatusResponses, unknown, ThrowOnError>({ url: "/bulletins/status", ...options });

export const getInternalStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetInternalStatusData, ThrowOnError>,
): RequestResult<GetInternalStatusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetInternalStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/status/internal",
    ...options,
  });

export const getPublicationStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetPublicationStatusData, ThrowOnError>,
): RequestResult<GetPublicationStatusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetPublicationStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/status/publication",
    ...options,
  });

/**
 * Submit bulletins
 */
export const submitBulletins = <ThrowOnError extends boolean = false>(
  options: Options<SubmitBulletinsData, ThrowOnError>,
): RequestResult<SubmitBulletinsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SubmitBulletinsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/submit",
    ...options,
  });

/**
 * Delete bulletin
 */
export const deleteJsonBulletin = <ThrowOnError extends boolean = false>(
  options: Options<DeleteJsonBulletinData, ThrowOnError>,
): RequestResult<DeleteJsonBulletinResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteJsonBulletinResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/{bulletinId}",
    ...options,
  });

/**
 * Get bulletin by ID
 */
export const getJsonBulletin = <ThrowOnError extends boolean = false>(
  options: Options<GetJsonBulletinData, ThrowOnError>,
): RequestResult<GetJsonBulletinResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetJsonBulletinResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/{bulletinId}",
    ...options,
  });

/**
 * Update bulletin
 */
export const updateJsonBulletin = <ThrowOnError extends boolean = false>(
  options: Options<UpdateJsonBulletinData, ThrowOnError>,
): RequestResult<UpdateJsonBulletinResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UpdateJsonBulletinResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/bulletins/{bulletinId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get checklists for a given date and region
 */
export const getChecklists = <ThrowOnError extends boolean = false>(
  options: Options<GetChecklistsData, ThrowOnError>,
): RequestResult<GetChecklistsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetChecklistsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/checklist",
    ...options,
  });

/**
 * Store checklist for a given date and region
 */
export const saveChecklist = <ThrowOnError extends boolean = false>(
  options: Options<SaveChecklistData, ThrowOnError>,
): RequestResult<SaveChecklistResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveChecklistResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/checklist",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get danger sources for season
 */
export const getDangerSources = <ThrowOnError extends boolean = false>(
  options: Options<GetDangerSourcesData, ThrowOnError>,
): RequestResult<GetDangerSourcesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetDangerSourcesResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/danger-sources",
    ...options,
  });

/**
 * Create or update danger source
 */
export const saveDangerSource = <ThrowOnError extends boolean = false>(
  options: Options<SaveDangerSourceData, ThrowOnError>,
): RequestResult<SaveDangerSourceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveDangerSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/danger-sources",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get danger source variants for date
 */
export const getVariants = <ThrowOnError extends boolean = false>(
  options: Options<GetVariantsData, ThrowOnError>,
): RequestResult<GetVariantsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetVariantsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/danger-sources/edit",
    ...options,
  });

export const getInternalStatus1 = <ThrowOnError extends boolean = false>(
  options: Options<GetInternalStatus1Data, ThrowOnError>,
): RequestResult<GetInternalStatus1Responses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetInternalStatus1Responses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/danger-sources/status",
    ...options,
  });

/**
 * Save danger source variant (create/insert or update)
 */
export const saveDangerSourceVariant = <ThrowOnError extends boolean = false>(
  options: Options<SaveDangerSourceVariantData, ThrowOnError>,
): RequestResult<SaveDangerSourceVariantResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveDangerSourceVariantResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/danger-sources/variants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Replace variants (save and delete obsolete)
 */
export const replaceVariants = <ThrowOnError extends boolean = false>(
  options: Options<ReplaceVariantsData, ThrowOnError>,
): RequestResult<ReplaceVariantsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReplaceVariantsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/danger-sources/variants/replace",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete danger source variant
 */
export const deleteVariant = <ThrowOnError extends boolean = false>(
  options: Options<DeleteVariantData, ThrowOnError>,
): RequestResult<DeleteVariantResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteVariantResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/danger-sources/variants/{variantId}",
    ...options,
  });

/**
 * Get variant by ID
 */
export const getVariantById = <ThrowOnError extends boolean = false>(
  options: Options<GetVariantByIdData, ThrowOnError>,
): RequestResult<GetVariantByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetVariantByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/danger-sources/variants/{variantId}",
    ...options,
  });

/**
 * Get danger source variants for danger source and date
 */
export const getVariantsForDangerSource = <ThrowOnError extends boolean = false>(
  options: Options<GetVariantsForDangerSourceData, ThrowOnError>,
): RequestResult<GetVariantsForDangerSourceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetVariantsForDangerSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/danger-sources/{dangerSourceId}/edit",
    ...options,
  });

/**
 * Subscribe email notification
 */
export const addSubscriber = <ThrowOnError extends boolean = false>(
  options: Options<AddSubscriberData, ThrowOnError>,
): RequestResult<AddSubscriberResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AddSubscriberResponses, unknown, ThrowOnError>({
    url: "/email/subscribe",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List incidents for a region (public report data when unauthenticated)
 */
export const getIncidents = <ThrowOnError extends boolean = false>(
  options: Options<GetIncidentsData, ThrowOnError>,
): RequestResult<GetIncidentsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetIncidentsResponses, unknown, ThrowOnError>({ url: "/incidents", ...options });

/**
 * Create an incident
 */
export const createIncident = <ThrowOnError extends boolean = false>(
  options: Options<CreateIncidentData, ThrowOnError>,
): RequestResult<CreateIncidentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateIncidentResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/incidents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete an incident
 */
export const deleteIncident = <ThrowOnError extends boolean = false>(
  options: Options<DeleteIncidentData, ThrowOnError>,
): RequestResult<DeleteIncidentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteIncidentResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/incidents/{id}",
    ...options,
  });

/**
 * Get an incident by ID (public data when unauthenticated)
 */
export const getIncident = <ThrowOnError extends boolean = false>(
  options: Options<GetIncidentData, ThrowOnError>,
): RequestResult<GetIncidentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetIncidentResponses, unknown, ThrowOnError>({ url: "/incidents/{id}", ...options });

/**
 * Update an incident
 */
export const updateIncident = <ThrowOnError extends boolean = false>(
  options: Options<UpdateIncidentData, ThrowOnError>,
): RequestResult<UpdateIncidentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateIncidentResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/incidents/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upload incident attachment
 */
export const uploadIncidentAttachment = <ThrowOnError extends boolean = false>(
  options: Options<UploadIncidentAttachmentData, ThrowOnError>,
): RequestResult<UploadIncidentAttachmentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UploadIncidentAttachmentResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/incidents/{id}/attachment",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Delete incident attachment
 */
export const deleteIncidentAttachment = <ThrowOnError extends boolean = false>(
  options: Options<DeleteIncidentAttachmentData, ThrowOnError>,
): RequestResult<DeleteIncidentAttachmentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteIncidentAttachmentResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/incidents/{id}/attachment/{attachmentId}",
    ...options,
  });

/**
 * Get incident attachment (public data when unauthenticated)
 */
export const getIncidentAttachment = <ThrowOnError extends boolean = false>(
  options: Options<GetIncidentAttachmentData, ThrowOnError>,
): RequestResult<GetIncidentAttachmentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetIncidentAttachmentResponses, unknown, ThrowOnError>({
    url: "/incidents/{id}/attachment/{attachmentId}",
    ...options,
  });

/**
 * Unpublish an incident
 */
export const unpublishIncident = <ThrowOnError extends boolean = false>(
  options: Options<UnpublishIncidentData, ThrowOnError>,
): RequestResult<UnpublishIncidentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<UnpublishIncidentResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/incidents/{id}/publish",
    ...options,
  });

/**
 * Publish an incident
 */
export const publishIncident = <ThrowOnError extends boolean = false>(
  options: Options<PublishIncidentData, ThrowOnError>,
): RequestResult<PublishIncidentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PublishIncidentResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/incidents/{id}/publish",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Save media file
 */
export const saveMediaFile = <ThrowOnError extends boolean = false>(
  options: Options<SaveMediaFileData, ThrowOnError>,
): RequestResult<SaveMediaFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveMediaFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/media",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Get media files as RSS feed
 */
export const getRssFeed = <ThrowOnError extends boolean = false>(
  options?: Options<GetRssFeedData, ThrowOnError>,
): RequestResult<GetRssFeedResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetRssFeedResponses, unknown, ThrowOnError>({ url: "/media/rss", ...options });

export const deleteGenericObservation = <ThrowOnError extends boolean = false>(
  options: Options<DeleteGenericObservationData, ThrowOnError>,
): RequestResult<DeleteGenericObservationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteGenericObservationResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/observations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getGenericObservations = <ThrowOnError extends boolean = false>(
  options: Options<GetGenericObservationsData, ThrowOnError>,
): RequestResult<GetGenericObservationsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetGenericObservationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/observations",
    ...options,
  });

export const saveOrUpdateGenericObservation = <ThrowOnError extends boolean = false>(
  options: Options<SaveOrUpdateGenericObservationData, ThrowOnError>,
): RequestResult<SaveOrUpdateGenericObservationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveOrUpdateGenericObservationResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/observations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getGenericObservation = <ThrowOnError extends boolean = false>(
  options: Options<GetGenericObservationData, ThrowOnError>,
): RequestResult<GetGenericObservationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetGenericObservationResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/observations/:source/:id",
    ...options,
  });

export const getOpenApiJson = <ThrowOnError extends boolean = false>(
  options?: Options<GetOpenApiJsonData, ThrowOnError>,
): RequestResult<GetOpenApiJsonResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetOpenApiJsonResponses, unknown, ThrowOnError>({ url: "/openapi.json", ...options });

export const getOpenApi = <ThrowOnError extends boolean = false>(
  options?: Options<GetOpenApiData, ThrowOnError>,
): RequestResult<GetOpenApiResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetOpenApiResponses, unknown, ThrowOnError>({ url: "/openapi.yml", ...options });

/**
 * Get VAPID public key
 */
export const key = <ThrowOnError extends boolean = false>(
  options?: Options<KeyData, ThrowOnError>,
): RequestResult<KeyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<KeyResponses, unknown, ThrowOnError>({ url: "/push/key", ...options });

/**
 * Subscribe push notification
 */
export const subscribe = <ThrowOnError extends boolean = false>(
  options: Options<SubscribeData, ThrowOnError>,
): RequestResult<SubscribeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SubscribeResponses, unknown, ThrowOnError>({
    url: "/push/subscribe",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Unsubscribe push notification
 */
export const unsubscribe = <ThrowOnError extends boolean = false>(
  options: Options<UnsubscribeData, ThrowOnError>,
): RequestResult<UnsubscribeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UnsubscribeResponses, unknown, ThrowOnError>({
    url: "/push/unsubscribe",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get all regions
 */
export const getRegions = <ThrowOnError extends boolean = false>(
  options?: Options<GetRegionsData, ThrowOnError>,
): RequestResult<GetRegionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetRegionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/regions",
    ...options,
  });

/**
 * Create or update region
 */
export const saveRegion = <ThrowOnError extends boolean = false>(
  options: Options<SaveRegionData, ThrowOnError>,
): RequestResult<SaveRegionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveRegionResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/regions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get region for ID
 */
export const getRegion = <ThrowOnError extends boolean = false>(
  options: Options<GetRegionData, ThrowOnError>,
): RequestResult<GetRegionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetRegionResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/regions/region",
    ...options,
  });

/**
 * Get local server configuration
 */
export const getLocalServerConfiguration = <ThrowOnError extends boolean = false>(
  options?: Options<GetLocalServerConfigurationData, ThrowOnError>,
): RequestResult<GetLocalServerConfigurationResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetLocalServerConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/server",
    ...options,
  });

/**
 * Create or update server configuration
 */
export const saveServerConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<SaveServerConfigurationData, ThrowOnError>,
): RequestResult<SaveServerConfigurationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveServerConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/server",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get external server configurations
 */
export const getExternalServerConfigurations = <ThrowOnError extends boolean = false>(
  options?: Options<GetExternalServerConfigurationsData, ThrowOnError>,
): RequestResult<GetExternalServerConfigurationsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetExternalServerConfigurationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/server/external",
    ...options,
  });

/**
 * Get server version info
 */
export const getServerVersionInfo = <ThrowOnError extends boolean = false>(
  options?: Options<GetServerVersionInfoData, ThrowOnError>,
): RequestResult<GetServerVersionInfoResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetServerVersionInfoResponses, unknown, ThrowOnError>({
    url: "/server/info",
    ...options,
  });

/**
 * Get bulletin statistics
 */
export const getBulletinCsv = <ThrowOnError extends boolean = false>(
  options: Options<GetBulletinCsvData, ThrowOnError>,
): RequestResult<GetBulletinCsvResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetBulletinCsvResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { regions: { array: { explode: false } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/statistics",
    ...options,
  });

/**
 * Get danger source statistics
 */
export const getDangerSourceCsv = <ThrowOnError extends boolean = false>(
  options: Options<GetDangerSourceCsvData, ThrowOnError>,
): RequestResult<GetDangerSourceCsvResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetDangerSourceCsvResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/statistics/danger-sources",
    ...options,
  });

/**
 * Save virtual reality statistics
 */
export const saveVirtualRealityStatistics = <ThrowOnError extends boolean = false>(
  options: Options<SaveVirtualRealityStatisticsData, ThrowOnError>,
): RequestResult<SaveVirtualRealityStatisticsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveVirtualRealityStatisticsResponses, unknown, ThrowOnError>({
    url: "/statistics/vr",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get status of publication channels that are associated with the current user's regions
 */
export const getStatus1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetStatus1Data, ThrowOnError>,
): RequestResult<GetStatus1Responses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetStatus1Responses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/status/channels",
    ...options,
  });

/**
 * Trigger status checks for all publication channels that are associated with the current user's regions
 */
export const triggerStatusChecks = <ThrowOnError extends boolean = false>(
  options?: Options<TriggerStatusChecksData, ThrowOnError>,
): RequestResult<TriggerStatusChecksResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<TriggerStatusChecksResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/status/channels",
    ...options,
  });

/**
 * Get all users
 */
export const getUsers = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersData, ThrowOnError>,
): RequestResult<GetUsersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/user",
    ...options,
  });

/**
 * Create or update user
 */
export const saveUser = <ThrowOnError extends boolean = false>(
  options: Options<SaveUserData, ThrowOnError>,
): RequestResult<SaveUserResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/user",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Change password
 */
export const changePassword = <ThrowOnError extends boolean = false>(
  options: Options<ChangePasswordData, ThrowOnError>,
): RequestResult<ChangePasswordResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ChangePasswordResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/user/change",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Check password
 */
export const checkPassword = <ThrowOnError extends boolean = false>(
  options: Options<CheckPasswordData, ThrowOnError>,
): RequestResult<CheckPasswordResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CheckPasswordResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/user/check",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get all regions
 */
export const getRegions1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetRegions1Data, ThrowOnError>,
): RequestResult<GetRegions1Responses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetRegions1Responses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/user/regions",
    ...options,
  });

/**
 * Get all roles
 */
export const getRoles = <ThrowOnError extends boolean = false>(
  options?: Options<GetRolesData, ThrowOnError>,
): RequestResult<GetRolesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetRolesResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/user/roles",
    ...options,
  });

/**
 * List stress level entries of user
 */
export const getStressLevels = <ThrowOnError extends boolean = false>(
  options: Options<GetStressLevelsData, ThrowOnError>,
): RequestResult<GetStressLevelsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetStressLevelsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/user/stress-level",
    ...options,
  });

/**
 * Create stress level entry
 */
export const postStressLevel = <ThrowOnError extends boolean = false>(
  options: Options<PostStressLevelData, ThrowOnError>,
): RequestResult<PostStressLevelResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PostStressLevelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/user/stress-level",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List stress level entries of team
 */
export const getTeamStressLevels = <ThrowOnError extends boolean = false>(
  options: Options<GetTeamStressLevelsData, ThrowOnError>,
): RequestResult<GetTeamStressLevelsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetTeamStressLevelsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/user/stress-level/team",
    ...options,
  });

/**
 * Delete user
 */
export const deleteUser = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUserData, ThrowOnError>,
): RequestResult<DeleteUserResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/user/{id}",
    ...options,
  });

/**
 * Reset user password
 */
export const resetPassword = <ThrowOnError extends boolean = false>(
  options: Options<ResetPasswordData, ThrowOnError>,
): RequestResult<ResetPasswordResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ResetPasswordResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/user/{id}/reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
